import * as React from 'react';
import styles from './FilterDelimiter.module.scss';
import cn from 'classnames';

function FilterDelimiter({
    height,
    classes,
    autoVerticalPosition
}: {
    height: string,
    classes?: string,
    autoVerticalPosition?: boolean
}) {
    return (
        <div
            className={cn(
                styles.root,
                classes,
                autoVerticalPosition && styles.withVerticalMargin
            )}
            style={{ height: height }}
        />
    );
}


export default FilterDelimiter;